<template>
  <div class="adminAddBox">
    <el-steps :active="active - 0" finish-status="success">
      <el-step title="填写考勤表信息"></el-step>
      <el-step title="上传考勤表数据"></el-step>
      <el-step title="已提交审核"></el-step>
    </el-steps>
    <el-tabs v-model="active" style="height: 500px">
      <el-tab-pane name="0" style="height: 500px">
        <Form
          ref="addForm"
          :label-width="130"
          :model="formCustom"
          :rules="addRules"
          inline
        >
          <Form-item label="所属厂站：" prop="deptId">
            <Select v-model="formCustom.deptId" :disabled='!isAdd' :label-in-value='true' clearable filterable
                    style="width: 240px" @on-change="changeDept">
              <Option v-for="item in deptList" :value="item.organizationId">{{ item.organizationName }}</Option>
            </Select>
          </Form-item>
          <Form-item label="考勤年月：" prop="attendanceDate">
            <DatePicker v-model="formCustom.attendanceDate" :disabled="!isAdd" type="month"/>
          </Form-item>
        </Form>
        <div style="cursor: pointer; width: 100px" @click="download()">
          <span style="color: #1890ff">下载模板</span
          ><i class="el-icon-download"></i>
        </div>
        <div>温馨提示：下载模板后，按照模板填写考勤信息后下一步上传。</div>
      </el-tab-pane>
      <el-tab-pane name="1" style="text-align: center">
        <el-tabs v-model="activeName" tab-position="left">
          <el-tab-pane name="1">
            <span slot="label" :style="{ color: showTable1 ? '#52c41a' : '' }"
            >节假日加班审批表</span
            >
            <template>
              <el-upload
                :action="BaseUrl + 'org/auth/companyAttendanceHoliday/upload'"
                :data="{ companyAttendanceId: companyAttendanceId }"
                :headers="headers"
                :on-error="handleError"
                :on-success="handleSuccess"
                class="upload-demo"
                drag
                multiple
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </template>
            <div style="width: 100%;text-align: left;">
              <el-button v-if="showTable1" icon="el-icon-delete" type="danger" @click="deletetable">删除</el-button>
            </div>
            <div v-if="showTable1">
              <Table
                :columns="columns1"
                :data="tableData1"
                :loading="loading1"
                aria-describedby=""
                aria-hidden="true" border
              >
                <template slot="auditStatus" slot-scope="{ row }">
                  {{
                    row.auditStatus == 1
                      ? "待提交"
                      : row.auditStatus == 2
                        ? "待审核"
                        : row.auditStatus == 3
                          ? "审核通过"
                          : row.auditStatus == 4
                            ? "审核拒绝"
                            : "待车管员审核"
                  }}
                </template>
              </Table>
              <Page
                ref="pages1"
                :current="page1"
                :total="total1"
                class="page_position"
                show-elevator
                show-sizer
                show-total
                style="margin-bottom: 80px"
                @on-change="setCurrent"
                @on-page-size-change="setPage"
              ></Page>
            </div>
          </el-tab-pane>
          <el-tab-pane name="2">
            <span slot="label" :style="{ color: showTable2 ? '#52c41a' : '' }"
            >双休加班审批表</span
            >
            <template>
              <el-upload
                :action="BaseUrl + 'org/auth/companyAttendanceWeekend/upload'"
                :data="{ companyAttendanceId: companyAttendanceId }"
                :headers="headers"
                :on-error="handleError"
                :on-success="handleSuccess"
                class="upload-demo"
                drag
                multiple
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </template>
            <div style="width: 100%;text-align: left;">
              <el-button v-if="showTable2" icon="el-icon-delete" type="danger" @click="deletetable">删除</el-button>
            </div>
            <div v-if="showTable2">
              <Table
                :columns="columns2"
                :data="tableData2"
                :loading="loading2"
                aria-describedby=""
                aria-hidden="true" border
              >
                <template slot="auditStatus" slot-scope="{ row }">
                  {{
                    row.auditStatus == 1
                      ? "待提交"
                      : row.auditStatus == 2
                        ? "待审核"
                        : row.auditStatus == 3
                          ? "审核通过"
                          : row.auditStatus == 4
                            ? "审核拒绝"
                            : "待车管员审核"
                  }}
                </template>
              </Table>
              <Page
                ref="pages2"
                :current="page2"
                :total="total2"
                class="page_position"
                show-elevator
                show-sizer
                show-total
                style="margin-bottom: 80px"
                @on-change="setCurrent"
                @on-page-size-change="setPage"
              ></Page>
            </div>
          </el-tab-pane>
          <el-tab-pane name="3">
            <span slot="label" :style="{ color: showTable3 ? '#52c41a' : '' }"
            >出差确认表</span
            >
            <template>
              <el-upload
                :action="BaseUrl + 'org/auth/companyAttendanceBusiness/upload'"
                :data="{ companyAttendanceId: companyAttendanceId }"
                :headers="headers"
                :on-error="handleError"
                :on-success="handleSuccess"
                class="upload-demo"
                drag
                multiple
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </template>
            <div style="width: 100%;text-align: left;">
              <el-button v-if="showTable3" icon="el-icon-delete" type="danger" @click="deletetable">删除</el-button>
            </div>
            <div v-if="showTable3">
              <Table
                :columns="columns3"
                :data="tableData3"
                :loading="loading3"
                aria-describedby=""
                aria-hidden="true" border
              >
                <template slot="auditStatus" slot-scope="{ row }">
                  {{
                    row.auditStatus == 1
                      ? "待提交"
                      : row.auditStatus == 2
                        ? "待审核"
                        : row.auditStatus == 3
                          ? "审核通过"
                          : row.auditStatus == 4
                            ? "审核拒绝"
                            : "待车管员审核"
                  }}
                </template>
              </Table>
              <Page
                ref="pages3"
                :current="page3"
                :total="total3"
                class="page_position"
                show-elevator
                show-sizer
                show-total
                style="margin-bottom: 80px"
                @on-change="setCurrent"
                @on-page-size-change="setPage"
              ></Page>
            </div>
          </el-tab-pane>
          <el-tab-pane name="4">
            <span slot="label" :style="{ color: showTable4 ? '#52c41a' : '' }"
            >夜餐补助审批表</span
            >
            <template>
              <el-upload
                :action="BaseUrl + 'org/auth/companyAttendanceNight/upload'"
                :data="{ companyAttendanceId: companyAttendanceId }"
                :headers="headers"
                :on-error="handleError"
                :on-success="handleSuccess"
                class="upload-demo"
                drag
                multiple
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </template>
            <div style="width: 100%;text-align: left;margin-bottom: 10px;">
              <el-button v-if="showTable4" icon="el-icon-delete" type="danger" @click="deletetable">删除</el-button>
            </div>
            <div v-if="showTable4">
              <Table
                :columns="columns4"
                :data="tableData4"
                :loading="loading4"
                aria-describedby=""
                aria-hidden="true" border
              >
                <template slot="auditStatus" slot-scope="{ row }">
                  {{
                    row.auditStatus == 1
                      ? "待提交"
                      : row.auditStatus == 2
                        ? "待审核"
                        : row.auditStatus == 3
                          ? "审核通过"
                          : row.auditStatus == 4
                            ? "审核拒绝"
                            : "待车管员审核"
                  }}
                </template>
              </Table>
              <Page
                ref="pages4"
                :current="page4"
                :total="total4"
                class="page_position"
                show-elevator
                show-sizer
                show-total
                style="margin-bottom: 80px"
                @on-change="setCurrent"
                @on-page-size-change="setPage"
              ></Page>
            </div>
          </el-tab-pane>
          <el-tab-pane name="6">
            <span slot="label" :style="{ color: showTable6 ? '#52c41a' : '' }"
            >请假审批表</span
            >
            <template>
              <el-upload
                :action="BaseUrl + 'org/auth/companyAttendanceLeave/upload'"
                :data="{ companyAttendanceId: companyAttendanceId }"
                :headers="headers"
                :on-error="handleError"
                :on-success="handleSuccess"
                class="upload-demo"
                drag
                multiple
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </template>
            <div style="width: 100%;text-align: left;margin-bottom: 10px;">
              <el-button v-if="showTable6" icon="el-icon-delete" type="danger" @click="deletetable">删除</el-button>
            </div>
            <div v-if="showTable6">
              <Table
                :columns="columns6"
                :data="tableData6"
                :loading="loading6"
                aria-describedby=""
                aria-hidden="true" border
              >
                <template slot="auditStatus" slot-scope="{ row }">
                  {{
                    row.auditStatus == 1
                      ? "待提交"
                      : row.auditStatus == 2
                        ? "待审核"
                        : row.auditStatus == 3
                          ? "审核通过"
                          : row.auditStatus == 4
                            ? "审核拒绝"
                            : "待车管员审核"
                  }}
                </template>
                <template slot="action" slot-scope="{ row }">
                  <Button size="small" type="text" @click="uploadShow(row)">上传附件</Button>
                </template>
                <template slot="leaveUrl" slot-scope="{ row }">
                  <Button v-if="row.leaveUrl" size="small" type="text" @click="leaveShow(row)">请假单</Button>
                </template>
              </Table>
              <Page
                ref="pages6"
                :current="page6"
                :total="total6"
                class="page_position"
                show-elevator
                show-sizer
                show-total
                style="margin-bottom: 80px"
                @on-change="setCurrent"
                @on-page-size-change="setPage"
              ></Page>
            </div>
          </el-tab-pane>
          <el-tab-pane name="5">
            <span slot="label" :style="{ color: showTable ? '#52c41a' : '' }"
            >考勤统计表</span
            >
            <template>
              <el-upload
                :action="BaseUrl + 'org/auth/companyAttendanceRecord/upload'"
                :data="{ companyAttendanceId: companyAttendanceId }"
                :headers="headers"
                :on-error="handleError"
                :on-success="handleSuccess"
                class="upload-demo"
                drag
                multiple
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </template>
            <div style="width: 100%;text-align: left;margin-bottom: 10px;">
              <el-button v-if="showTable" icon="el-icon-delete" type="danger" @click="deletetable">删除</el-button>
            </div>
            <div v-if="showTable">
              <Table
                :columns="(this.roleType === 0 || this.roleType === 3 || this.roleType === 4) ? columns : columnsNoIdNumber"
                :data="tableData"
                :loading="loading"
                aria-describedby=""
                aria-hidden="true" border
              >
                <template slot="auditStatus" slot-scope="{ row }">
                  {{
                    row.auditStatus == 1
                      ? "待提交"
                      : row.auditStatus == 2
                        ? "待审核"
                        : row.auditStatus == 3
                          ? "审核通过"
                          : "审核拒绝"
                  }}
                </template>
              </Table>
              <Page
                ref="pages5"
                :current="page"
                :total="total"
                class="page_position"
                show-elevator
                show-sizer
                show-total
                style="margin-bottom: 80px"
                @on-change="setCurrent"
                @on-page-size-change="setPage"
              ></Page>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane name="2">
        <div style="width: 100%;display: flex;flex-direction: column;align-items: center;">
          <div class="success">
            <p>
              <i
                class="el-icon-success"
                style="color: #52c41a; margin-top: 100px; font-size: 100px"
              ></i>
            </p>
            <p style="margin-top: 20px">提交成功</p>
            <p style="margin-top: 20px">5秒后自动跳转至外籍雇员管理列表</p>
            <Button style="margin-top: 20px" type="primary" @click="handleBack"
            >返回外籍雇员管理列表
            </Button
            >
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="footerButton">
      <Button type="default" @click="handleBack('add')">返回</Button>
      <Button v-if="active == '0'" :loading="nextloading" type="primary" @click="next">下一步</Button>
      <Button v-if="active == '1'" type="primary" @click="next"
      >提交审核
      </Button
      >
    </div>
    <el-dialog :visible.sync="dialogVisible" title="上传附件" width="500px" @close="close">
      <el-upload
        :action="BaseUrl + 'api/auth/file'"
        :data="{companyAttendanceLeaveId: companyAttendanceLeaveId }"
        :fileList="fileList"
        :headers="headers"
        :on-error="handleErrorfile"
        :on-success="handleSuccessfile"
        class="upload-demo"
        drag
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或<em>点击上传</em>
        </div>
      </el-upload>
      <el-button type="primary" @click="submitFile">确认</el-button>
    </el-dialog>
  </div>
</template>

<script>
import {
  businessDelete,
  companyAttendanceAdd,
  companyAttendanceBusinessPage,
  companyAttendanceHolidayPage,
  companyAttendanceInit,
  companyAttendanceLeaveDelete,
  companyAttendanceLeavePage,
  companyAttendanceLeavePut,
  companyAttendanceNightPage,
  companyAttendancePut,
  companyAttendanceRecordPage,
  companyAttendanceSubmitAudit,
  companyAttendanceWeekendPage,
  downloadErr,
  holidayDelete,
  nightDelete,
  recordDelete,
  weekendDelete
} from "@/api/attendance";

export default {
  name: "adminAdd",
  data() {
    return {
      addLoading: false,
      BaseUrl: process.env.VUE_APP_BASE_URL,
      deptList: [], // 所属厂站下拉框
      deptId: "", // 下拉框所属厂站ID
      formCustom: {
        deptId: "",
        attendanceDate: "",
      },
      addRules: {
        deptId: [{required: true, message: '所属厂站不能为空', trigger: 'change', type: 'number'}],
        attendanceDate: [{required: true, message: "考勤年月不能为空"}],
      },
      active: "0",
      companyAttendanceId: "",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      columns: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属厂站", key: "deptName", align: "left"},
        {title: "姓名", key: "employeeRealName", align: "center"},
        {title: "身份证号", key: "employeeIdNumber", align: "center"},
        {title: "职务", key: "employeePositionName", align: "center"},
        {title: "出勤天数", key: "employeeAttendanceDays", align: "center"},
        {title: "晚班", key: "employeeNightDays", align: "center"},
        {title: "出差天数", key: "employeeBusinessDays", align: "center"},
        {
          title: "双休加班",
          key: "employeeWeekendOvertimeDays",
          align: "center",
        },
        {
          title: "节假日加班",
          key: "employeeHolidayOvertimeDays",
          align: "center",
        },
        {title: "中巴车出车", key: "employeeBusWorkCount", align: "center"},
        {title: "换乘费次数", key: "employeeTransferCount", align: "center"},
        {title: "请假天数", key: "employeeLeaveDays", align: "center"},
        {title: "其他", key: "employeeOther", align: "center"},
      ],
      columnsNoIdNumber: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属厂站", key: "deptName", align: "left"},
        {title: "姓名", key: "employeeRealName", align: "center"},
        {title: "职务", key: "employeePositionName", align: "center"},
        {title: "出勤天数", key: "employeeAttendanceDays", align: "center"},
        {title: "晚班", key: "employeeNightDays", align: "center"},
        {title: "出差天数", key: "employeeBusinessDays", align: "center"},
        {
          title: "双休加班",
          key: "employeeWeekendOvertimeDays",
          align: "center",
        },
        {
          title: "节假日加班",
          key: "employeeHolidayOvertimeDays",
          align: "center",
        },
        {title: "中巴车出车", key: "employeeBusWorkCount", align: "center"},
        {title: "换乘费次数", key: "employeeTransferCount", align: "center"},
        {title: "请假天数", key: "employeeLeaveDays", align: "center"},
        {title: "其他", key: "employeeOther", align: "center"},
      ],
      tableData: [],
      loading: false,
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      showTable: false,
      columns2: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "日期", key: "weekendDate", align: "center"},
        {title: "加班时间", key: "weekendDays", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "事由", key: "weekendCause", align: "center"},
        {title: "是否调休", key: "isChangeTime", align: "center"},
        {title: "是否申请加班工资", key: "isChangeAmount", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      tableData1: [],
      loading1: false,
      total1: 0,
      page1: 1,
      size1: 10,
      pageSize1: 10,
      showTable1: false,
      columns1: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "日期", key: "holidayDate", align: "center"},
        {title: "加班时间", key: "holidayDays", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "事由", key: "holidayCause", align: "center"},
        {title: "是否调休", key: "isChangeTime", align: "center"},
        {title: "是否申请加班工资", key: "isChangeAmount", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      tableData2: [],
      loading2: false,
      total2: 0,
      page2: 1,
      size2: 10,
      pageSize2: 10,
      showTable2: false,
      columns3: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "起始日期", key: "businessDate", align: "center"},
        {title: "目的地", key: "businessDestination", align: "center"},
        {title: "同行人签字", key: "businessFellow", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      tableData3: [],
      loading3: false,
      total3: 0,
      page3: 1,
      size3: 10,
      pageSize3: 10,
      showTable3: false,
      columns4: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "日期", key: "nightDate", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "事由", key: "nightCause", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      tableData4: [],
      loading4: false,
      total4: 0,
      page4: 1,
      size4: 10,
      pageSize4: 10,
      showTable4: false,
      columns6: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "请假起止日期", key: "leaveDate", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "实际请假天数", key: "leaveDays", align: "center"},
        {title: "请假类型", key: "leaveType", align: "center"},
        {title: "事由", key: "leaveCause", align: "center"},
        {title: "附件", slot: "leaveUrl", key: "leaveUrl", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
        {
          title: "操作",
          key: "action",
          slot: "action",
          align: "center",
        }
      ],
      tableData6: [],
      loading6: false,
      total6: 0,
      page6: 1,
      size6: 10,
      pageSize6: 10,
      showTable6: false,
      timers: null,
      countDown: null,
      downloadUrl: "",
      activeName: "1",
      isAdd: true,
      dialogVisible: false,
      companyAttendanceLeaveId: "",
      fileList: [],
      upRow: {},
      nextloading: false,
      roleType: ''
    };
  },
  mounted() {
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.roleType = user.roleType;

    if (this.$route.query.companyAttendanceId) {
      this.companyAttendanceId = this.$route.query.companyAttendanceId;
      this.formCustom.deptId = Number(this.$route.query.deptId);
      this.formCustom.attendanceDate = this.$route.query.attendanceDate;
      this.isAdd = false
    } else {
      this.isAdd = true
    }
    companyAttendanceInit().then((res) => {
      this.deptList = res.data.data.orgOrganizationList;
      this.downloadUrl = res.data.data.templatePath;
    });
  },
  methods: {
    leaveShow(row) {
      row.leaveUrl.split(",").forEach((e) => {
        window.open(e, '_blank')
      })
    },
    handleSuccessfile(response, file, fileList) {
      console.log(this.fileList)
      console.log(fileList)
      this.fileList = fileList
    },
    handleErrorfile(response, file, fileList) {
      console.log(this.fileList)
    },
    submitFile() {
      if (this.fileList.length == 0) {
        this.$message.error('请先上传附件')
        return;
      }
      const list = [];
      this.fileList.forEach((e) => {
        list.push(this.$getImgFile + e.response.data)
      })
      const params = {
        companyAttendanceLeaveId: this.companyAttendanceLeaveId,
        companyAttendanceId: this.companyAttendanceId,
        attendanceDate: this.upRow.attendanceDate,
        companyId: this.upRow.companyId,
        leaveUrl: list.join(",")
      };
      companyAttendanceLeavePut(params).then((res) => {
        this.dialogVisible = false
        this.handleSuccess()
      })
    },
    uploadShow(row) {
      this.upRow = row
      this.companyAttendanceLeaveId = row.companyAttendanceLeaveId
      this.fileList = []
      this.dialogVisible = true
    },
    close() {
      this.fileList = []
    },
    // 返回
    next() {
      let a = Number(this.active);
      this.nextloading = true
      if (a == 0) {
        //添加考勤
        this.$refs["addForm"].validate((valid) => {
          if (valid) {
            if (this.companyAttendanceId) {
              companyAttendancePut({
                attendanceDate: this.formCustom.attendanceDate && this.$moment(this.formCustom.attendanceDate).format("YYYY-MM"),
                companyId: this.formCustom.deptId,
                companyAttendanceId: this.companyAttendanceId
              }).then((res) => {
                a++;
                this.active = a.toString();
                this.success();
                this.nextloading = false
              });
            } else {
              companyAttendanceAdd({
                attendanceDate: this.formCustom.attendanceDate && this.$moment(this.formCustom.attendanceDate).format("YYYY-MM"),
                companyId: this.deptId,
                companyName: this.formCustom.deptName
              }).then((res) => {
                if (res.data.success === false) {
                  this.$Message.error(res.data.msg);
                } else {
                  this.companyAttendanceId = res.data.data;
                  a++;
                  this.nextloading = false
                  this.active = a.toString();
                }
              });
            }
          }
        });
      } else if (a == 1) {
        if (this.showTable) {
          companyAttendanceSubmitAudit({
            companyAttendanceId: this.companyAttendanceId,
          })
            .then((res) => {
              console.log(res);
              if (res.data.success) {
                a++;
                this.active = a.toString();
                this.nextloading = false
                this.count();
              } else {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((error) => {
              this.$Message.error("提交审核失败");
            });
        } else {
          this.$Message.error("请先上传考勤信息");
        }
        //上传完考勤，调用审核
      } else if (a == 2) {
        //返回页面countSecond()
        a++;
        this.active = a.toString();
        this.nextloading = false
        this.count();
      }
    },
    count() {
      const count = 5;
      this.countDown = count;
      this.timers = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--;
        } else {
          clearInterval(this.timers);
          this.$router.push({path: "/companyAttendance/companyAttendance"});
        }
      }, 1000);
    },
    // 导入成功
    success() {
      companyAttendanceRecordPage({
        companyAttendanceId: this.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.total = res.data.data.total;
        this.size = res.data.data.size;
        this.tableData = res.data.data.records;
        this.loading = false;
        if (res.data.data.total) {
          this.showTable = true;
        }
      });
      companyAttendanceHolidayPage({
        companyAttendanceId: this.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.total1 = res.data.data.total;
        this.size1 = res.data.data.size;
        this.tableData1 = res.data.data.records;
        this.loading1 = false;
        if (res.data.data.total) {
          this.showTable1 = true;
        }
      });
      companyAttendanceWeekendPage({
        companyAttendanceId: this.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.total2 = res.data.data.total;
        this.size2 = res.data.data.size;
        this.tableData2 = res.data.data.records;
        this.loading2 = false;
        if (res.data.data.total) {
          this.showTable2 = true;
        }
      });
      companyAttendanceBusinessPage({
        companyAttendanceId: this.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.total3 = res.data.data.total;
        this.size3 = res.data.data.size;
        this.tableData3 = res.data.data.records;
        this.loading3 = false;
        if (res.data.data.total) {
          this.showTable3 = true;
        }
      });
      companyAttendanceNightPage({
        companyAttendanceId: this.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.total4 = res.data.data.total;
        this.size4 = res.data.data.size;
        this.tableData4 = res.data.data.records;
        this.loading4 = false;
        if (res.data.data.total) {
          this.showTable4 = true;
        }
      });
      companyAttendanceLeavePage({
        companyAttendanceId: this.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.total6 = res.data.data.total;
        this.size6 = res.data.data.size;
        this.tableData6 = res.data.data.records;
        this.loading6 = false;
        if (res.data.data.total) {
          this.showTable6 = true;
        }
      });
    },
    // 上传后获取详情
    handleSuccess(response, file, fileList) {
      this.$Message.success("导入成功");
      if (this.activeName == 5) {
        companyAttendanceRecordPage({
          companyAttendanceId: this.companyAttendanceId,
          current: 1,
          size: 10,
        }).then((res) => {
          this.total = res.data.data.total;
          this.size = res.data.data.size;
          this.tableData = res.data.data.records;
          this.loading = false;
          if (res.data.data.total) {
            this.showTable = true;
          }
        });
      }
      if (this.activeName == 1) {
        companyAttendanceHolidayPage({
          companyAttendanceId: this.companyAttendanceId,
          current: 1,
          size: 10,
        }).then((res) => {
          this.total1 = res.data.data.total;
          this.size1 = res.data.data.size;
          this.tableData1 = res.data.data.records;
          this.loading1 = false;
          if (res.data.data.total) {
            this.showTable1 = true;
          }
        });
      }
      if (this.activeName == 2) {
        companyAttendanceWeekendPage({
          companyAttendanceId: this.companyAttendanceId,
          current: 1,
          size: 10,
        }).then((res) => {
          this.total2 = res.data.data.total;
          this.size2 = res.data.data.size;
          this.tableData2 = res.data.data.records;
          this.loading2 = false;
          if (res.data.data.total) {
            this.showTable2 = true;
          }
        });
      }
      if (this.activeName == 3) {
        companyAttendanceBusinessPage({
          companyAttendanceId: this.companyAttendanceId,
          current: 1,
          size: 10,
        }).then((res) => {
          this.total3 = res.data.data.total;
          this.size3 = res.data.data.size;
          this.tableData3 = res.data.data.records;
          this.loading3 = false;
          if (res.data.data.total) {
            this.showTable3 = true;
          }
        });
      }
      if (this.activeName == 4) {
        companyAttendanceNightPage({
          companyAttendanceId: this.companyAttendanceId,
          current: 1,
          size: 10,
        }).then((res) => {
          this.total4 = res.data.data.total;
          this.size4 = res.data.data.size;
          this.tableData4 = res.data.data.records;
          this.loading4 = false;
          if (res.data.data.total) {
            this.showTable4 = true;
          }
        });
      }
      if (this.activeName == 6) {
        companyAttendanceLeavePage({
          companyAttendanceId: this.companyAttendanceId,
          current: 1,
          size: 10,
        }).then((res) => {
          this.total6 = res.data.data.total;
          this.pageSize6 = res.data.data.size;
          this.tableData6 = res.data.data.records;
          this.loading6 = false;
          if (res.data.data.total) {
            this.showTable6 = true;
          }
        });
      }
    },
    // 导入失败
    handleError(err, file) {
      if (err) {
        const erro = JSON.parse(err.message);
        if (erro.code === "100050") {
          this.$alert("导入失败，请查看错误提示模版", "提示", {
            confirmButtonText: "确定",
          });
          downloadErr({delete: true, fileName: erro.data}).then((res) => {
            if (res) {
              const link = document.createElement("a");
              let blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              });
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              switch (this.activeName) {
                case "1":
                  link.download = "节假日加班审批表错误信息统计.xlsx";
                  break;
                case "2":
                  link.download = "双休加班审批表错误信息统计.xlsx";
                  break;
                case "3":
                  link.download = "出差确认表错误信息统计.xlsx";
                  break;
                case "4":
                  link.download = "夜餐补助审批表错误信息统计.xlsx";
                  break;
                case "5":
                  link.download = "企业考勤明细错误信息统计.xlsx";
                  break;
                case "6":
                  link.download = "请假审批表信息统计.xlsx";
                  break;
                default:
                  break;
              }
              // 下载的文件名
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          });
        } else {
          this.$alert(erro.msg, "提示", {
            confirmButtonText: "确定",
          });
        }
      }
    },
    changeData(res) {
      if (res) {
        if (this.activeName == 1) {
          this.total1 = res.data.data.total;
          this.size1 = res.data.data.size;
          this.tableData1 = res.data.data.records;
          this.loading1 = false;
          if (res.data.data.total) {
            this.showTable1 = true;
          }
        }
        if (this.activeName == 2) {
          this.total2 = res.data.data.total;
          this.size2 = res.data.data.size;
          this.tableData2 = res.data.data.records;
          this.loading2 = false;
          if (res.data.data.total) {
            this.showTable2 = true;
          }
        }
        if (this.activeName == 3) {
          this.total3 = res.data.data.total;
          this.size3 = res.data.data.size;
          this.tableData3 = res.data.data.records;
          this.loading3 = false;
          if (res.data.data.total) {
            this.showTable3 = true;
          }
        }
        if (this.activeName == 4) {
          this.total4 = res.data.data.total;
          this.size4 = res.data.data.size;
          this.tableData4 = res.data.data.records;
          this.loading4 = false;
          if (res.data.data.total) {
            this.showTable4 = true;
          }
        }
        if (this.activeName == 6) {
          this.total6 = res.data.data.total;
          this.size6 = res.data.data.size;
          this.tableData6 = res.data.data.records;
          this.loading6 = false;
          if (res.data.data.total) {
            this.showTable6 = true;
          }
        } else if (this.activeName == 5) {
          this.total = res.data.data.total;
          this.size = res.data.data.size;
          this.tableData = res.data.data.records;
          this.loading = false;
          if (res.data.data.total) {
            this.showTable = true;
          }
        }
      }
    },
    setCurrent(val) {
      if (this.activeName == 1) {
        this.loading1 = true;
        this.page1 = val;
        companyAttendanceHolidayPage({
          companyAttendanceId: this.companyAttendanceId,
          current: val,
          size: this.pageSize1,
        }).then((res1) => {
          this.changeData(res1);
        });
      }
      if (this.activeName == 2) {
        this.loading2 = true;
        this.page2 = val;
        companyAttendanceWeekendPage({
          companyAttendanceId: this.companyAttendanceId,
          current: val,
          size: this.pageSize2,
        }).then((res1) => {
          this.changeData(res1);
        });
      }
      if (this.activeName == 3) {
        this.loading3 = true;
        this.page3 = val;
        companyAttendanceBusinessPage({
          companyAttendanceId: this.companyAttendanceId,
          current: val,
          size: this.pageSize1,
        }).then((res1) => {
          this.changeData(res1);
        });
      }
      if (this.activeName == 4) {
        this.loading4 = true;
        this.page4 = val;
        companyAttendanceNightPage({
          companyAttendanceId: this.companyAttendanceId,
          current: val,
          size: this.pageSize4,
        }).then((res1) => {
          this.changeData(res1);
        });
      }
      if (this.activeName == 6) {
        this.loading6 = true;
        this.page6 = val;
        companyAttendanceLeavePage({
          companyAttendanceId: this.companyAttendanceId,
          current: val,
          size: this.pageSize6,
        }).then((res1) => {
          this.changeData(res1);
        });
      }
      if (this.activeName == 5) {
        this.loading = true;
        this.page = val;
        companyAttendanceRecordPage({
          companyAttendanceId: this.companyAttendanceId,
          current: val,
          size: this.pageSize,
        }).then((res1) => {
          this.changeData(res1);
        });
      }
    },
    // 改变每页条数
    setPage(val) {
      if (this.activeName == 1) {
        this.loading1 = true;
        this.pageSize1 = val;
        companyAttendanceHolidayPage({
          companyAttendanceId: this.companyAttendanceId,
          current: this.page1,
          size: val,
        }).then((res1) => {
          this.changeData(res1);
          this.$refs["pages1"].currentPage = 1; // 分页变成第一页
        });
      }
      if (this.activeName == 2) {
        this.loading2 = true;
        this.pageSize2 = val;
        companyAttendanceWeekendPage({
          companyAttendanceId: this.companyAttendanceId,
          current: this.page2,
          size: val,
        }).then((res1) => {
          this.changeData(res1);
          this.$refs["pages2"].currentPage = 1; // 分页变成第一页
        });
      }
      if (this.activeName == 3) {
        this.loading3 = true;
        this.pageSize3 = val;
        companyAttendanceBusinessPage({
          companyAttendanceId: this.companyAttendanceId,
          current: this.page3,
          size: val,
        }).then((res1) => {
          this.changeData(res1);
          this.$refs["pages3"].currentPage = 1; // 分页变成第一页
        });
      }
      if (this.activeName == 4) {
        this.loading4 = true;
        this.pageSize4 = val;
        companyAttendanceNightPage({
          companyAttendanceId: this.companyAttendanceId,
          current: this.page4,
          size: val,
        }).then((res1) => {
          this.changeData(res1);
          this.$refs["pages4"].currentPage = 1; // 分页变成第一页
        });
      }
      if (this.activeName == 6) {
        this.loading6 = true;
        this.pageSize6 = val;
        companyAttendanceLeavePage({
          companyAttendanceId: this.companyAttendanceId,
          current: this.page6,
          size: val,
        }).then((res1) => {
          this.changeData(res1);
          this.$refs["pages6"].currentPage = 1; // 分页变成第一页
        });
      }
      if (this.activeName == 5) {
        this.loading = true;
        this.pageSize = val;
        companyAttendanceRecordPage({
          companyAttendanceId: this.companyAttendanceId,
          current: this.page,
          size: val,
        }).then((res1) => {
          this.changeData(res1);
          this.$refs["pages5"].currentPage = 1; // 分页变成第一页
        });
      }
    },
    handleBack() {
      this.$router.push({
        path: "/companyAttendance/companyAttendance",
      });
    },
    download() {
      window.open(this.downloadUrl, "_blank");
    },
    deletetable() {
      if (this.activeName == 1) {
        this.loading1 = true;
        holidayDelete({
          companyAttendanceId: this.companyAttendanceId,
        }).then((res) => {
          this.$Message.success('删除成功');
          companyAttendanceHolidayPage({
            companyAttendanceId: this.companyAttendanceId,
            current: this.page1,
            size: this.pageSize1,
          }).then((res1) => {
            this.changeData(res1);
            this.$refs["pages1"].currentPage = 1; // 分页变成第一页
          });
        })
      }
      if (this.activeName == 2) {
        this.loading2 = true;
        weekendDelete({
          companyAttendanceId: this.companyAttendanceId,
        }).then((res) => {
          this.$Message.success('删除成功');
          companyAttendanceWeekendPage({
            companyAttendanceId: this.companyAttendanceId,
            current: this.page2,
            size: this.pageSize2,
          }).then((res1) => {
            this.changeData(res1);
            this.$refs["pages2"].currentPage = 1; // 分页变成第一页
          });
        })
      }
      if (this.activeName == 3) {
        this.loading3 = true;
        businessDelete({
          companyAttendanceId: this.companyAttendanceId,
        }).then((res) => {
          this.$Message.success('删除成功');
          companyAttendanceBusinessPage({
            companyAttendanceId: this.companyAttendanceId,
            current: this.page3,
            size: this.pageSize3,
          }).then((res1) => {
            this.changeData(res1);
            this.$refs["pages3"].currentPage = 1; // 分页变成第一页
          })
        })
      }
      if (this.activeName == 4) {
        this.loading4 = true;
        nightDelete({
          companyAttendanceId: this.companyAttendanceId,
        }).then((res) => {
          this.$Message.success('删除成功');
          companyAttendanceNightPage({
            companyAttendanceId: this.companyAttendanceId,
            current: this.page4,
            size: this.pageSize4,
          }).then((res1) => {
            this.changeData(res1);
            this.$refs["pages4"].currentPage = 1; // 分页变成第一页
          })
        })
      }
      if (this.activeName == 6) {
        this.loading6 = true;
        companyAttendanceLeaveDelete({
          companyAttendanceId: this.companyAttendanceId,
        }).then((res) => {
          this.$Message.success('删除成功');
          companyAttendanceLeavePage({
            companyAttendanceId: this.companyAttendanceId,
            current: this.page6,
            size: this.pageSize6,
          }).then((res1) => {
            this.changeData(res1);
            this.$refs["pages6"].currentPage = 1; // 分页变成第一页
          })
        })
      }
      if (this.activeName == 5) {
        this.loading = true;
        recordDelete({
          companyAttendanceId: this.companyAttendanceId,
        }).then((res) => {
          this.$Message.success('删除成功');
          companyAttendanceRecordPage({
            companyAttendanceId: this.companyAttendanceId,
            current: this.page,
            size: this.pageSize,
          }).then((res1) => {
            this.changeData(res1);
            this.$refs["pages5"].currentPage = 1; // 分页变成第一页
          })
        })
      }
    },
    // 获取下拉框所属厂站数据
    changeDept(val) {
      if (val !== undefined) {
        this.deptId = val.value
        this.formCustom.deptName = val.label
      }
    }
  },
};
</script>
<style>
.success {
  width: 702px;
  height: 502px;
  line-height: 17px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(235, 235, 235, 1);
}
</style>
